import moment from 'moment';
import en from 'antd/lib/locale/en_US';
import ru from 'antd/lib/locale/ru_RU';
import es from 'antd/lib/locale/es_ES';
import zh from 'antd/lib/locale/zh_CN';

import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/zh-cn';

export const ANTD_LOCALES = {
  en,
  ru,
  es,
  zh,
};

const MOMENT_LOCALES = {
  en: 'en',
  ru: 'ru',
  es: 'es',
  zh: 'zh-cn',
};

export const setMomentLocale = (language) => {
  moment.locale(MOMENT_LOCALES[language] || MOMENT_LOCALES.en);
};
